const sqlFunctions = [
    "SELECT",
    "FROM",
    "WHERE",
    "INSERT",
    "UPDATE",
    "DELETE",
    "CREATE",
    "ALTER",
    "DROP",
    "INDEX",
    "TABLE",
    "VIEW",
    "JOIN",
    "INNER JOIN",
    "LEFT JOIN",
    "RIGHT JOIN",
    "FULL JOIN",
    "ON",
    "GROUP BY",
    "HAVING",
    "ORDER BY",
    "DISTINCT",
    "AS",
    "BETWEEN",
    "IN",
    "LIKE",
    "IS NULL",
    "IS NOT NULL",
    "UNION",
    "ALL",
    "ANY",
    "SOME",
    "EXISTS",
    "CASE",
    "WHEN",
    "THEN",
    "ELSE",
    "END",
    "VALUES",
    "SET",
    "LIMIT",
    "OFFSET",
    "TRANSACTION",
    "COMMIT",
    "ROLLBACK",
    "SAVEPOINT",
    "GRANT",
    "REVOKE",
    "USER",
    "DATABASE",
    "SCHEMA",
    "FOREIGN KEY",
    "PRIMARY KEY",
    "DEFAULT",
    "CHECK",
    "UNIQUE",
    "ALTER TABLE",
    "TRUNCATE",
    "CROSS JOIN",
    "NATURAL JOIN",
    "SUM",
    "MIN",
    "MAX",
    "AVG",
    "COUNT",
    "ROUND",
    "MOD",
    "CAST",
    "CONVERT",
    "COALESCE",
    "IFNULL",
    "NULLIF",
    "GREATEST",
    "LEAST",
    "TRIM",
    "SUBSTRING",
    "REPLACE",
    "UPPER",
    "LOWER",
    "CHAR_LENGTH",
    "LENGTH",
    "POSITION",
    "LOCATE",
    "EXTRACT",
    "DATE_ADD",
    "DATE_SUB",
    "NOW",
    "CURDATE",
    "CURTIME",
    "DAY",
    "MONTH",
    "YEAR",
    "HOUR",
    "MINUTE",
    "SECOND",
    "CURRENT_TIMESTAMP",
    "CURRENT_DATE",
    "CURRENT_TIME",
    "DATEDIFF",
    "TIMESTAMPDIFF",
    "STR_TO_DATE",
    "FORMAT",
    "LEFT",
    "RIGHT",
    "CONCAT",
    "REVERSE",
    "SUBSTR",
    "LPAD",
    "RPAD",
    "REGEXP",
    "INTERSECT",
    "EXCEPT",
    "FETCH",
    "FOR UPDATE",
    "WITH",
    "RECURSIVE",
    "WINDOW",
    "RANK",
    "ROW_NUMBER",
    "DENSE_RANK",
    "PARTITION BY",
    "LAG",
    "LEAD",
    "FIRST_VALUE",
    "LAST_VALUE",
    "NTILE",
    "RANDOM",
    "UNBOUNDED",
    "PRECEDING",
    "FOLLOWING",
    "ROWCOUNT",
    "IS DISTINCT FROM",
    "MERGE",
    "OUTER APPLY",
    "CROSS APPLY",
    "PIVOT",
    "UNPIVOT",
    "FULLTEXT",
    "MATCH",
    "AGAINST",
    "WITH ROLLUP",
    "WITH CUBE",
    "GROUPING",
    "GROUPING SETS",
    "BIT_AND",
    "BIT_OR",
    "BIT_XOR",
    "ASCII",
    "BIN",
    "OCT",
    "HEX",
    "CHAR",
    "MD5",
    "SHA1",
    "SHA2",
    "PASSWORD",
    "UUID",
    "INET_ATON",
    "INET_NTOA",
    "INET6_ATON",
    "INET6_NTOA",
    "IS_IPV4",
    "IS_IPV6",
    "IS_IPV4_COMPAT",
    "IS_IPV4_MAPPED",
    "INET6_ATON",
    "JSON_OBJECT",
    "JSON_ARRAY",
    "JSON_VALUE",
    "JSON_EXTRACT",
    "JSON_INSERT",
    "JSON_SET",
    "JSON_REMOVE",
    "JSON_MERGE",
    "XMLAGG",
    "XMLEXISTS",
    "XMLQUERY",
    "XMLTABLE",
    "XMLPARSE",
    "XMLSERIALIZE",
    "CUBE",
    "ROLLUP",
    "LIMIT",
    "OFFSET",
    "ARRAY_AGG",
    "ARRAY",
    "ARRAY_TO_STRING",
    "STRING_TO_ARRAY",
    "CARDINALITY",
    "UNNEST",
    "TABLESAMPLE",
    "SYSTEM",
    "BERNOULLI",
    "ANALYZE",
    "EXPLAIN",
    "CLUSTER",
    "VACUUM",
    "OPTIMIZE",
    "REINDEX",
    "SEQUENCE",
    "CYCLE",
    "IDENTITY",
    "GENERATED",
    "DEFAULT VALUES",
    "INVOKER",
    "DEFINER",
    "CUME_DIST",
    "PERCENT_RANK",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC",
    "NTILE",
    "RECURSIVE",
    "CONNECT BY",
    "START WITH",
    "LEVEL",
    "PRIOR",
    "SYS_CONNECT_BY_PATH",
    "CONNECT_BY_ROOT",
    "CROSS APPLY",
    "OUTER APPLY",
    "UNSIGNED",
    "ZEROFILL",
    "AUTO_INCREMENT",
    "ENUM",
    "SET",
    "BINARY",
    "VARBINARY",
    "BIGINT",
    "MEDIUMINT",
    "SMALLINT",
    "TINYINT",
    "DECIMAL",
    "DOUBLE",
    "FLOAT",
    "TINYBLOB",
    "BLOB",
    "MEDIUMBLOB",
    "LONGBLOB",
    "TINYTEXT",
    "TEXT",
    "MEDIUMTEXT",
    "LONGTEXT",
    "ENUM",
    "SET",
    "GEOMETRY",
    "POINT",
    "LINESTRING",
    "POLYGON",
    "MULTIPOINT",
    "MULTILINESTRING",
    "MULTIPOLYGON",
    "GEOMETRYCOLLECTION",
    "ST_DISTANCE",
    "ST_WITHIN",
    "ST_CONTAINS",
    "ST_TOUCHES",
    "ST_INTERSECTS",
    "ST_EQUALS",
    "ST_OVERLAPS",
    "ST_CROSSES",
    "ST_DISJOINT",
    "ST_BUFFER",
    "ST_UNION",
    "ST_DIFFERENCE",
    "ST_SYMDIFF",
    "ST_INTERSECTION",
    "ST_AREA",
    "ST_LENGTH",
    "ST_CENTROID",
    "ST_BOUNDARY",
    "ST_ENVELOPE",
    "ST_TRANSFORM",
    "SPATIAL INDEX",
    "SOUNDEX",
    "DIFFERENCE",
    "METAPHONE",
    "DOUBLE METAPHONE",
    "HASH",
    "CRC32",
    "SQL_CALC_FOUND_ROWS",
    "FOUND_ROWS",
    "GET_LOCK",
    "RELEASE_LOCK",
    "IS_FREE_LOCK",
    "IS_USED_LOCK",
    "MASTER_POS_WAIT",
    "SHOW TABLES",
    "SHOW COLUMNS",
    "SHOW INDEX",
    "SHOW CREATE TABLE",
    "SHOW PROCESSLIST",
    "SHOW VARIABLES",
    "SHOW STATUS",
    "SHOW GRANTS",
    "SHOW ERRORS",
    "SHOW WARNINGS",
    "LOAD DATA INFILE",
    "OUTFILE",
    "LOCK TABLES",
    "UNLOCK TABLES",
    "FLUSH",
    "RESET QUERY CACHE",
    "DESCRIBE",
    "EXISTS",
    "IS JSON",
    "ROW_FORMAT",
    "KEY_BLOCK_SIZE",
    "(ab)",
  ];
export {sqlFunctions};